export default [
  {
    id: 'schedule',
    owner: 'client',
    tasks: [
      {
        step: 0,
        text: 'You schedule your consultation',
        done: 'You scheduled your consultation'
      }
    ],
    actions: [
      {
        step: 0,
        text: 'View booking details',
        method: 'viewBookingDetails',
        condition: 'shouldShowBookingDetails',
        sticky: true
      },
      {
        step: 0,
        text: 'Schedule consultation',
        method: 'scheduleConsultation'
      }
    ]
  },
  {
    id: 'conflict-check',
    owner: 'admin',
    tasks: [
      {
        step: 1,
        text: 'We conduct a conflict check',
        details: 'This step usually takes 1-2 business days. You will receive an email when your conflict check is completed.',
        done: 'We conducted the conflict check'
      }
    ],
    actions: [
      {
        step: 1,
        condition: 'isUserAdmin',
        text: 'Conflict check clear',
        method: 'clearConflictCheck'
      },
    ]
  },
  {
    id: 'consultation',
    owner: 'client',
    tasks: [
      {
        step: 2,
        text: 'Phone consultation with attorney',
        done: 'You had a phone consultation'
      }
    ],
    actions: [
      {
        step: 2,
        text: 'Mark as done',
        condition: 'isUserAdmin',
        method: 'completeConsultation'
      }
    ]
  },
  {
    id: 'send-engagement',
    owner: 'admin',
    tasks: [
      {
        step: 3,
        text: 'We send the engagement letter',
        done: 'We sent the engagement letter'
      }
    ],
    actions: [
      {
        step: 3,
        text: 'Release engagement letter',
        condition: 'isUserAdmin',
        method: 'releaseEngagementLetter'
      }
    ]
  },
  {
    id: 'sign-engagement',
    owner: 'client',
    tasks: [
      {
        step: 4,
        text: 'You sign the engagement letter',
        done: 'You signed the engagement letter'
      }
    ],
    actions: [
      {
        step: 4,
        text: 'Sign engagement letter',
        method: 'signEngagementLetter'
      }
    ]
  },
  {
    id: 'charge-card',
    owner: 'client',
    tasks: [
      {
        step: 5,
        text: 'Authorize credit card payment',
        done: 'You paid'
      }
    ],
    actions: [
      {
        step: 5,
        text: 'Charge card on file',
        method: 'chargeCard'
      }
    ]
  },
  {
    id: 'submit-docs',
    owner: 'client',
    tasks: [
      {
        step: 6,
        text: 'You add supporting details & upload relevant documents',
        done: 'You added details & documents'
      }
    ],
    actions: [
      {
        step: 6,
        text: 'Add supporting details',
        method: 'goToSupportingDetails'
      }
    ]
  },
  {
    id: 'review-draft',
    owner: 'admin',
    tasks: [
      {
        step: 7,
        text: 'We review your submission details',
        done: 'We reviewed your submission details'
      },
      {
        step: 8,
        text: 'We draft the patent application or revise the patent application based on your input',
        done: 'We drafted the patent application'
      }
    ],
    actions: [
      {
        step: 7,
        text: 'Add client number',
        condition: 'shouldShowAddClientNumberButton',
        method: 'editProfile'
      },
      {
        step: 7,
        text: 'View submission details',
        condition: 'isUserAdmin',
        method: 'viewSubmissionDetails'
      },
      {
        step: 8,
        text: 'Upload draft',
        condition: 'isUserAdmin',
        method: 'editProfileApplicationTab'
      },
      {
        step: 8,
        text: 'Release draft',
        condition: 'isUserAdmin',
        method: 'releaseDraft'
      },
    ]
  },
  {
    id: 'approve-draft',
    owner: 'client',
    tasks: [
      {
        step: 9,
        text: 'You leave feedback on draft, or approve draft as-is',
        done: 'You approved the draft'
      }
    ],
    actions: [
      {
        step: 9,
        text: 'View draft',
        method: 'clientViewDraft'
      },
      {
        step: 9,
        text: 'Submit feedback',
        method: 'clientSubmitFeedback'
      },
      {
        step: 9,
        text: 'Approve draft as-is',
        method: 'clientApproveDraft'
      }
    ]
  },
  {
    id: 'file-notify',
    owner: 'admin',
    tasks: [
      {
        step: 10,
        text: 'We finalize the draft. This could take up to 2 weeks. We\'ll email you when this is done.',
        done: 'We finalized the draft'
      },
      {
        step: 11,
        text: 'We file with US Patent office',
        done: 'We filed with US Patent office'
      },
      {
        step: 12,
        text: 'Congratulations! Your invention is now patent-pending. We notify you of the USPTO assigned serial number',
        done: 'We notified you of the USPTO assigned serial number'
      },
      {
        step: 13,
        text: 'All done',
        done: 'All done'
      }
    ],
    actions: [
      {
        step: 10,
        text: 'Upload new draft',
        condition: 'isUserAdmin',
        method: 'editProfileApplicationTab'
      },
      {
        step: 10,
        text: 'Mark as complete',
        condition: 'isUserAdmin',
        method: 'completeDraft'
      },
      {
        step: 11,
        text: 'Upload as-filed application',
        condition: 'shouldShowUploadAsFiledButton',
        method: 'editProfileApplicationTab'
      },
      {
        step: 11,
        text: 'Add serial number',
        condition: 'shouldShowAddSerialNumberButton',
        method: 'editProfileApplicationTab'
      },
      {
        step: 11,
        text: 'Add filing date',
        condition: 'shouldShowAddFilingDateButton',
        method: 'addFilingDate'
      },
      {
        step: 11,
        text: 'Filed',
        condition: 'isUserAdmin',
        method: 'markAsFiled'
      },
      {
        step: 12,
        text: 'Upload filing receipt',
        condition: 'shouldShowUploadFilingReceiptButton',
        method: 'editProfileApplicationTab'
      },
      {
        step: 12,
        text: 'Report out to client',
        condition: 'isUserAdmin',
        method: 'reportOutToClient'
      },
    ]
  }
]